export const GET_NOTES_LIST_SUCCESS = 'GET_NOTES_LIST_SUCCESS';
export const GET_NOTES_BOOKS_LIST_SUCCESS = 'GET_NOTES_BOOKS_LIST_SUCCESS';
export const GET_NOTES_DOWNLOAD_ADDRESS = 'GET_NOTES_DOWNLOAD_ADDRESS';
export const LOADING_MESSAGE = '正在为您加载课程笔记信息...';
export const SET_COURSE_IDX = 'SET_COURSE_IDX';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
